export var createMuiTableContainerOverrides = function () {
    return {
        styleOverrides: {
            root: {
                position: 'relative',
            },
        },
    };
};
